import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../variables';
import { LetterboxLinkAtom } from '@atoms/link-atoms/link-atoms';
import { LetterboxContainerProps } from './letterbox-container.types';

// @TODO unit tests
const LetterBoxContainer: React.FC<LetterboxContainerProps> = ({
  links,
  linksGtmId,
  className,
}) => {
  return (
    <div className={className} data-testid="letterbox-container">
      {links.map((link, index) => (
        <LetterboxLinkAtom
          gtmId={linksGtmId ? linksGtmId : null}
          url={link.url}
          key={`${index}--${link.name.slice(0, 3)}`}
        >
          {link.name}
        </LetterboxLinkAtom>
      ))}
    </div>
  );
};

// === LetterBoxContainer CSS ===
const StyledLetterBoxContainer = styled(LetterBoxContainer)`
  width: 30.8rem;
  height: 100%;
  background-color: white;
  padding: ${vars.spacingM};
  ${LetterboxLinkAtom} {
    ${vars.fontSize1}
  }
  @media screen and (min-width: ${vars.breakPointFullWidth}) {
    border: 1px dashed ${vars.borderGrey};
  }
`;

export default StyledLetterBoxContainer;
